import { render, staticRenderFns } from "./tabPaginatedTable.vue?vue&type=template&id=1a4d76fc"
import script from "./tabPaginatedTable.vue?vue&type=script&lang=js"
export * from "./tabPaginatedTable.vue?vue&type=script&lang=js"
import style0 from "./tabPaginatedTable.vue?vue&type=style&index=0&id=1a4d76fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports